import Box from 'v2/components/UI/Box';
import * as SC from './styles';
import { IInputWithIcon } from './types';
import Icon from 'v2/components/Icon';

const InputWithIcon: React.FC<IInputWithIcon> = ({
  iconName,
  iconColor,
  disabled,
  placeholder,
  type,
  value,
  isSearch,
  width,
  maxWidth,
  onChange,
}) => {
  const renderIcon = () => {
    if (isSearch) {
      return (
        <Icon iconName={'SearchOutlined'} size={18} htmlColor={'#B5B5B5'} />
      );
    }
    if (iconName && iconColor) {
      return <Icon iconName={iconName} size={18} htmlColor={iconColor} />;
    }
  };

  return (
    <Box
      border={'1px solid #EFEFEF'}
      borderRadius={10}
      padding={10}
      width={width ?? '100%'}
      maxWidth={maxWidth ?? '100%'}
      display="flex"
      alignItems="center"
      gap={10}
    >
      {renderIcon()}
      <SC.Input
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        type={type}
        onChange={onChange}
      />
    </Box>
  );
};

export default InputWithIcon;
